import React from 'react';

export default function renderListView(props) {

    const classes = Classes('gd-field-total', 'ui5-txt-less-important-small', props.renderMode, props.className, {
        'not-set': _.isNil(props.value)
    });

    if (!!props.value) {
        return <div className={classes}>
            <div className="ui5-ico-13 i5-chat m-r-5" />
            {props.value}
        </div>
    } else {
        return <div className={classes} />
    }
}